export default "__VITE_ASSET__Bmj9fuC7__"